module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/code/lock-circle-70d0ff0cd796f2bcc2d774972d77ece4.svg";